import InputBase from "@mui/material/InputBase";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import styled from "styled-components";
import { SM_FONT_SIZE } from "../Common/StyleElement";

const handleInputWidth = (display) => {
    switch (display) {
        case 'true':
            return "200px";
        case 'false':
            return 0;
        default:
            return "100%";
    }
};

const handleFormWidth = (display) => {
    switch (display) {
        case 'true':
            return "fit-content";
        case 'false':
            return 0;
        default:
            return "100%";
    }
};

export const BootstrapInput = styled(InputBase)`
    font-size: ${SM_FONT_SIZE} !important;

    & .MuiInputAdornment-root {
        position: absolute;
        right: 9px;
    }
    & .MuiInputBase-input {
        ${(props) =>
            props.disabled
                ? ``
                : `&:hover {
            border: 1px solid #333;
        }`}
        width: ${({ display }) => handleInputWidth(display)};
        position: relative;
        border: 1px solid #c4c4c4;
        border-radius: 6px;
        padding: 10px 39px 10px 12px;
        transition: all cubic-bezier(0.19, 1, 0.22, 1) 0.6s;
    }
`;

export const BootstrapFormControl = styled(FormControl)`
    width: ${({ display }) => handleFormWidth(display)};
    overflow: hidden;
    transition: all cubic-bezier(0.19, 1, 0.22, 1) 0.6s;
`;

export const CustomMenuItem = styled(MenuItem)`
    font-size: ${SM_FONT_SIZE} !important;
    display: block !important;
    margin-bottom: 1px !important;
    margin-left: 5px !important;
`;
